import { createBrowserHistory } from 'history';

export default createBrowserHistory({
  basename: '',
  forceRefresh: false,
  keyLength: 6
});
